import React from "react";

const PaymentButtonOptions = ({
    payButtons,
    editpayButtonData,
    setpayEditButtonData,
    handleSavePaymentEdit,
}) => {
    return (
        <div className="setting-payment-container">
            <table className="setting-payment-table">
                <thead>
                    <tr>
                        <th>Button Name</th>
                        <th>Show at checkout</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {payButtons.map((btn) => (
                        <tr key={btn.id}>
                            <td>{btn.button}</td>
                            <td>{btn.default ? "Yes" : "No"}</td>
                            <td>
                                <button
                                    className="setting-cart-edit-btn"
                                    onClick={() => setpayEditButtonData({ ...btn })}
                                >
                                    <i className="fa-solid fa-pencil"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {editpayButtonData && (
                <div className="setting-cart-modal">
                    <div className="setting-cart-modal-content">
                        <h3 className="setting-payment-modal-title">Edit Payment Button</h3>

                        <label className="setting-payment-label">Button Name</label>
                        <input
                            type="text"
                            value={editpayButtonData.button}
                            onChange={(e) =>
                                setpayEditButtonData({ ...editpayButtonData, button: e.target.value })
                            }
                            className="setting-payment-input "
                        />

                        <label className="setting-payment-label">
                            <input
                                type="checkbox"
                                checked={editpayButtonData.default}
                                onChange={(e) =>
                                    setpayEditButtonData({ ...editpayButtonData, default: e.target.checked })
                                }
                            />
                            <span className="setting-payment-checkbox-label">Show at checkout</span>
                        </label>
                        {(editpayButtonData.button_id === "manualpay" ||
                            editpayButtonData.button_id === "paymanual") && (
                            <p style={{ fontSize: "13px", color: "#666", margin: "8px 0 0" }}>
                                Manual Payment is exclusive — when enabled, Pay Now and Pay on
                                delivery are hidden at checkout.
                            </p>
                        )}

                        <div className="setting-payment-modal-actions">
                            <button
                                className="setting-payment-save"
                                onClick={handleSavePaymentEdit}
                            >
                                Save
                            </button>
                            <button
                                className="setting-payment-cancel"
                                onClick={() => setpayEditButtonData(null)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PaymentButtonOptions;
